import { DirectionalHint, TooltipHost, ZIndexes } from "@fluentui/react";
import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const CustomToolTipHost = (props) => {
  const { getThemeColor } = useContext(themeContext);

  const styles =
    props.styles != undefined && props.styles != null ? props.styles : {};
  const content = props.content;
  const id = props.id != null && props.id != undefined ? props.id : "random_";
  const directionalHint =
    props.directionalHint != null && props.directionalHint != undefined
      ? true
      : false;

  const toolTipProps =  props.toolTipProps!=undefined && props.toolTipProps!=null? props.toolTipProps :{
    calloutProps: {
      styles: {
        beak: { background: getThemeColor("tooltip") },
        beakCurtain: { background: getThemeColor("tooltip") },
        calloutMain: { background: getThemeColor("tooltip") },
        borderRadius: "5px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      },
    },
  };

  return directionalHint ? (
    <TooltipHost
      styles={styles}
      content={content}
      id={id}
      tooltipProps={toolTipProps}
      directionalHint={props.directionalHint}
    >
      {props.children}
    </TooltipHost>
  ) : (
    <TooltipHost
      styles={styles}
      content={content}
      id={id}
      tooltipProps={toolTipProps}
    >
      {props.children}
    </TooltipHost>
  );
};

export default CustomToolTipHost;
